import { Box, Tooltip, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type TempZoneColorPresetsProps = {
  onSelect: (color: string) => void;
};

export default function TempZoneColorPresets({
  onSelect
}: TempZoneColorPresetsProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  const presets = [
    {
      key: "ambient",
      label: t("ambient"),
      color: theme.palette.ambient.main
    },
    {
      key: "chilled",
      label: t("chilled"),
      color: theme.palette.chilled.main
    },
    {
      key: "frozen",
      label: t("frozen"),
      color: theme.palette.frozen.main
    }
  ];

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {presets.map((preset) => (
        <Tooltip key={preset.key} title={preset.label}>
          <Box
            component="button"
            type="button"
            aria-label={preset.label}
            onClick={() => onSelect(preset.color)}
            sx={{
              width: 24,
              height: 24,
              p: 0,
              borderRadius: "50%",
              border: "1px solid",
              borderColor: "divider",
              bgcolor: preset.color,
              cursor: "pointer",
              flexShrink: 0
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
